<script setup>
  import { onMounted, getCurrentInstance } from 'vue'

  const { proxy } = getCurrentInstance()

  onMounted(() => {
    console.debug(
      'App mounted, env:',
      proxy.$currentEnv,
      ' isProduction: ',
      proxy.$isProduction
    )
    if (!proxy.$isProduction) return
    setupClarity()
  })

  const setupClarity = () => {
    const _script = document.createElement('script')
    _script.setAttribute('type', 'text/javascript')
    _script.innerHTML = `
      ;(function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          ;(c[a].q = c[a].q || []).push(arguments)
        }
      t = l.createElement(r)
      t.async = 1
      t.src = 'https://www.clarity.ms/tag/' + i
      y = l.getElementsByTagName(r)[0]
      y.parentNode.insertBefore(t, y)
    })(window, document, 'clarity', 'script', 'm5s28q3zw6')
  `
    document.head.appendChild(_script)
    console.debug('Clarity script loaded')
  }
</script>

<template>
  <RouterView />
</template>

<style lang="scss">
  // Main Stylesheet
  @import '@/assets/scss/main';

  @import '@/assets/scss/oneui/themes/amethyst';

  @import 'vue-select/dist/vue-select.css';
  @import '@/assets/scss/vendor/_vue-select.scss';
  @import '@/assets/scss/vendor/vue-select-themes.scss';

  @import 'flatpickr/dist/flatpickr.css';
  @import '@/assets/scss/vendor/flatpickr';
</style>
